import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-open",
  "use": "icon-open-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 14\" id=\"icon-open\">\n    <path fill=\"currentColor\" d=\"M10.348 0L8.485 1.806 6.652.024 0 2.909l2.182 2.188v5.811l6.303 2.905 6.304-2.905V5.097L17 2.886 10.348 0zm.252 1.328l4.435 1.923-1.231 1.232-4.491-1.907L10.6 1.328zm-4.2.023l1.26 1.225-4.493 1.907-1.202-1.209L6.4 1.351zm2.085 2.088l3.988 1.693-3.988 1.691-3.987-1.691 3.987-1.693zM3.328 5.85l4.584 1.945v4.524l-4.584-2.113V5.848zm10.315 0v4.356l-4.585 2.113V7.794l4.585-1.946z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol